'use client';

import * as React from 'react';
import { Grid2 as Grid, type Grid2Props as GridProps } from '@unity/cloud-ui';
import themeConstants from '@/components/theme/theme-constants';

export const PageCenterGrid = (props: GridProps) => {
  return (
    <Grid
      sx={{
        height: `calc(100svh - ${themeConstants.layout.headerHeight})`,
        width: '100%',
      }}
      {...props}
    />
  );
};
